import { render, staticRenderFns } from "./costAscription.vue?vue&type=template&id=fd80b1f8&scoped=true"
import script from "./costAscription.vue?vue&type=script&lang=js"
export * from "./costAscription.vue?vue&type=script&lang=js"
import style0 from "./costAscription.vue?vue&type=style&index=0&id=fd80b1f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd80b1f8",
  null
  
)

export default component.exports